// src/hooks/useFilterFormLogic.js
import { useState, useEffect } from 'react';
import { TICKET_FREE, TICKET_PAID } from '../constants/eventTypes';

const useFilterFormLogic = (filters) => {
  // Estado temporal para los filtros "otros"
  const [tempOtherFilters, setTempOtherFilters] = useState({
    typology: filters.typology || [],
    terrain: filters.terrain || [],
    experience: filters.experience || [],
    ticketType: filters.ticketType || [],
    needsVehicle: filters.needsVehicle || [],
    vehicleTypes: filters.vehicleTypes || []
  });

  // Sincroniza el estado temporal cuando cambian los filtros
  useEffect(() => {
    setTempOtherFilters({
      typology: [...filters.typology],
      terrain: Array.isArray(filters.terrain) ? [...filters.terrain] : filters.terrain ? [filters.terrain] : [],
      experience: Array.isArray(filters.experience) ? [...filters.experience] : filters.experience ? [filters.experience] : [],
      ticketType: Array.isArray(filters.ticketType) ? [...filters.ticketType] : filters.ticketType ? [filters.ticketType] : [],
      needsVehicle: Array.isArray(filters.needsVehicle) ? [...filters.needsVehicle] : filters.needsVehicle ? [filters.needsVehicle] : [],
      vehicleTypes: Array.isArray(filters.vehicleTypes) ? [...filters.vehicleTypes] : filters.vehicleTypes ? [filters.vehicleTypes] : []
    });
  }, [filters]);

  useEffect(() => {
    console.log("tempOtherFilters updated:", tempOtherFilters);
  }, [tempOtherFilters]);

  // const handleOtherFiltersChange = (filterName, value, overwrite = false) => {
  //   setTempOtherFilters(prev => {
  //     const currentValues = Array.isArray(prev[filterName]) ? [...prev[filterName]] : [];

  //     // Handle 'all' logic first
  //     if (value === 'all') {
  //       const allValuesMap = {
  //         terrain: ['road', 'offroad'],
  //         experience: ['beginner', 'intermediate', 'advanced'],
  //         ticketType: [TICKET_FREE, TICKET_PAID],
  //         needsVehicle: ['true', 'false']
  //       };

  //       if (allValuesMap[filterName]) {
  //         const allValues = allValuesMap[filterName];
  //         const allSelected = allValues.every(val => currentValues.includes(val));
  //         return {
  //           ...prev,
  //           [filterName]: allSelected ? [] : allValues
  //         };
  //       }
  //     }

  //     // Normal toggle logic - prevent adding 'all' to any array
  //     let newValues;
  //     if (overwrite) {
  //       newValues = Array.isArray(value) ? [...value] : [value];
  //     } else {
  //       // Add null check and filter out 'all' if present
  //       const sanitizedCurrent = currentValues.filter(v => v !== 'all');
  //       const valueIndex = sanitizedCurrent.indexOf(value);
  //       newValues = valueIndex === -1
  //         ? [...sanitizedCurrent, value]
  //         : sanitizedCurrent.filter(v => v !== value);
  //     }

  //     return { ...prev, [filterName]: newValues };
  //   });
  // };

  // const handleOtherFiltersChange = (filterName, value, overwrite = false) => {
  //   setTempOtherFilters(prev => {
  //     if (overwrite) {
  //       return { ...prev, [filterName]: Array.isArray(value) ? [...value] : [value] };
  //     }
  //     let currentValues = Array.isArray(prev[filterName])
  //       ? prev[filterName].filter(v => v !== 'all')
  //       : [];

  //     if (value === 'all') {
  //       const allValuesMap = {
  //         terrain: ['road', 'offroad'],
  //         experience: ['beginner', 'intermediate', 'advanced'],
  //         ticketType: [TICKET_FREE, TICKET_PAID],
  //         needsVehicle: ['true', 'false']
  //       };
  //       const allValues = allValuesMap[filterName] || [];
  //       if (!allValues.every(val => currentValues.includes(val))) {
  //         return { ...prev, [filterName]: allValues };
  //       } else {
  //         return { ...prev, [filterName]: [] };
  //       }
  //     }
  //     const index = currentValues.indexOf(value);
  //     const newValues = index === -1
  //       ? [...currentValues, value]
  //       : currentValues.filter(v => v !== value);
  //     return { ...prev, [filterName]: newValues };
  //   });
  // };

  const handleOtherFiltersChange = (filterName, value, overwrite = false) => {
    setTempOtherFilters(prev => {
      if (overwrite) {
        // Se reemplaza el array completo
        return { ...prev, [filterName]: Array.isArray(value) ? [...value] : [value] };
      }
      // Toggle normal: agrega o quita la opción individual
      const currentValues = Array.isArray(prev[filterName]) ? [...prev[filterName]] : [];
      const index = currentValues.indexOf(value);
      const newValues = index === -1 ? [...currentValues, value] : currentValues.filter(v => v !== value);
      return { ...prev, [filterName]: newValues };
    });
  };

  const handleResetOtherFilters = () => {
    setTempOtherFilters({
      typology: [],
      terrain: [],
      experience: [],
      ticketType: [],
      needsVehicle: [],
      vehicleTypes: []
    });
  };

  return {
    tempOtherFilters,
    setTempOtherFilters,
    handleOtherFiltersChange,
    handleResetOtherFilters
  };
};

export default useFilterFormLogic;
